import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'fun-overview-bar',
  templateUrl: './overview-bar.component.html',
  styleUrls: ['./overview-bar.component.scss'],
   providers: [DecimalPipe]
})
export class OverviewBarComponent implements OnInit {

  @Input() data: any;
  @Input() hiddePercent: boolean = false;
  @Input() hiddeObjetive: boolean = false;
  @Input() size: string = 'm';

  barWidth: number;
  percent: number;
  leftPercent: number;
  objetiveParse: string;
  minExceeded: boolean = false;
  total: number;

  constructor(private chdRef: ChangeDetectorRef, private decimalPipe: DecimalPipe) { }

  ngOnInit() {
    this.getData();
    this.chdRef.detectChanges();
  }

  getData() {
    this.data.contributed = this.data.reserved + this.data.contributed;
    if (this.data.contributed > this.data.total_official && this.data.total_official > 0) {
      this.minExceeded = true;
    }
    this.total = this.data.total_official && this.data.total_official > 0 && this.data.contributed < this.data.total_official ? this.data.total_official : this.data.total;
    this.percent = (this.data.contributed / this.total) * 100;
    this.leftPercent = this.percent <= 5 ? 6 : this.percent > 94 ? 90 : this.percent;
    this.barWidth = this.percent < 2.5 ? 2.5 : this.percent > 100 ? 100 : this.percent;
    this.objetiveParse = this.getObjetiveParse();
    this.chdRef.detectChanges();
  }

  getObjetiveParse() {
    if (this.data.total < 1000000) {
      return this.decimalPipe.transform(this.data.total, '1.0-0', 'es') + ' €';
    } else {
      const millionsObj = this.data.total / 1000000;
      return this.decimalPipe.transform(millionsObj, '1.0-2', 'es') + ' M€';
    }
  }

}
